import { ReactNode } from 'react'
import { Container } from './styles'
import { useUncontrolled } from '../../hooks/use-uncontrolled'

interface IProps {
  children?: ReactNode

  value?: boolean
  onChange?(value: boolean): void
  defaultValue?: boolean

  className?: string
}

const Checkbox = (props: IProps) => {
  const [value, handleChange] = useUncontrolled({
    value: props.value,
    defaultValue: props.defaultValue || false,
    onChange: props.onChange,
  })

  return (
    <Container className={props.className}>
      <input type="checkbox" checked={value} onChange={(e) => handleChange(e.target.checked)} />
      <span className="indicator" data-checked={value}></span>
      <div className="checkbox-label">{props.children}</div>
    </Container>
  )
}

export default Checkbox
